import { useRef, useState } from 'react';
import { uploadDocument, deleteDocument, buildFileUrl } from './api';

const SECTION_LABELS = {
  info:       { label: 'Основная информация', icon: '🐾' },
  vacc:       { label: 'Обработки',           icon: '💉' },
  weight:     { label: 'Вес',                 icon: '⚖️' },
  care:       { label: 'Уход',                icon: '✂️' },
  treatment:  { label: 'Лечение',             icon: '💊' },
  visits:     { label: 'Визиты к врачу',      icon: '🏥' },
  lab:        { label: 'Анализы',             icon: '🔬' },
  nutrition:  { label: 'Питание',             icon: '🥩' },
  reactions:  { label: 'Реакции',             icon: '🍽️' },
  schedule:   { label: 'Расписание',          icon: '📅' },
  contacts:   { label: 'Контакты',            icon: '📞' },
  petsitter:  { label: 'Пет ситтер',          icon: '🤝' },
};

// ── Просмотр документов секции ──────────────────────────────────────────
export function SectionDocsModal({ petId, section, docs, onClose, onDeleted, canDelete = true }) {
  const [deleting, setDeleting] = useState(null);
  const info = SECTION_LABELS[section] || { label: section, icon: '📄' };

  const handleDelete = async (docId) => {
    setDeleting(docId);
    try {
      await deleteDocument(petId, docId);
      onDeleted(docId);
    } catch {
      alert('Ошибка при удалении');
    } finally {
      setDeleting(null);
    }
  };

  const openDoc = (docId) => {
    const url = buildFileUrl(`/api/pets/${petId}/documents/${docId}/download`);
    window.open(url, '_blank');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">{info.icon} {info.label}</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        {docs.length === 0 ? (
          <p style={{ color: '#888', fontSize: 14, padding: '8px 0' }}>Нет документов</p>
        ) : (
          <div className="docs-list">
            {docs.map((doc) => (
              <div key={doc.id} className="doc-row">
                <button
                  className="doc-name"
                  onClick={() => openDoc(doc.id)}
                >
                  📄 {doc.original_name}
                </button>
                {canDelete && (
                  <button
                    className="doc-delete"
                    onClick={() => handleDelete(doc.id)}
                    disabled={deleting === doc.id}
                  >
                    {deleting === doc.id ? '⏳' : '🗑️'}
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ── Загрузка нового документа ────────────────────────────────────────────
export function UploadModal({ petId, onClose, onUploaded }) {
  const [section, setSection] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const handleUpload = async () => {
    if (!section || !file) return;
    setUploading(true);
    try {
      const doc = await uploadDocument(petId, section, file);
      onUploaded(doc);
      onClose();
    } catch (e) {
      alert(`Ошибка: ${e.message}`);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">📎 Прикрепить документ</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="upload-form">
          <label className="upload-label">Раздел</label>
          <div className="section-grid">
            {Object.entries(SECTION_LABELS).map(([key, { label, icon }]) => (
              <button
                key={key}
                className={`section-chip ${section === key ? 'section-chip-active' : ''}`}
                onClick={() => setSection(key)}
              >
                {icon} {label}
              </button>
            ))}
          </div>

          <label className="upload-label" style={{ marginTop: 16 }}>Файл</label>
          <button className="file-pick-btn" onClick={() => fileRef.current.click()}>
            {file ? `📄 ${file.name}` : '+ Выбрать файл'}
          </button>
          <input
            ref={fileRef}
            type="file"
            style={{ display: 'none' }}
            onChange={(e) => setFile(e.target.files[0] || null)}
          />

          <button
            className="upload-submit"
            onClick={handleUpload}
            disabled={!section || !file || uploading}
          >
            {uploading ? 'Загрузка...' : 'Прикрепить'}
          </button>
        </div>
      </div>
    </div>
  );
}
